// extracted by mini-css-extract-plugin
export default {"-large":"contextual-menu-tabs-header-module__-large--hN5pB","tabs":"contextual-menu-tabs-header-module__tabs--UEd8E"};